/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Tournament_2_HeadingInputs */

const en_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance without the tradeoff`)
};

const es_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento sin la falsa elección`)
};

const de_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistung ohne Kompromisse`)
};

const zh_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表现无需取舍`)
};

const ar_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أداء دون المقايضة الزائفة`)
};

const fr_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des performances sans compromis`)
};

const vi_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiệu suất không đánh đổi giả`)
};

const sw_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utendaji bila kujinyima`)
};

const th_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประสิทธิภาพโดยไม่ต้องแลก`)
};

const bs_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performans bez lažnog izbora`)
};

const ja_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トレードオフのないパフォーマンス`)
};

const ko_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`거래없이 성능`)
};

const pt_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desempenho sem tradeoff`)
};

const it_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestazioni senza tradeoff`)
};

const sv_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestanda utan tradeoff`)
};

const nl_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestaties zonder verrekening`)
};

const da_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Præstation uden kompromis`)
};

const nb_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utførelse uten avlevering`)
};

const fi_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`suositella`)
};

const pl_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydajność bez odsprzedaży`)
};

const ru_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Производительность без компромисса`)
};

const tr_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödün vermeden performans`)
};

const hi_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`व्यापार के बिना प्रदर्शन`)
};

const id_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performa tanpa harus berkorban`)
};

const ms_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasi tanpa perlu berkorban`)
};

const cs_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asi to bude fungovat bez obchodu.`)
};

const el_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Απόδοση χωρίς την ανταλλαγή`)
};

const he_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ביצועים ללא הסכם`)
};

const af_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasie sonder verrekening`)
};

const hu_method_content_step_06_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítmény kompromisszum nélkül`)
};

/**
* | output |
* | --- |
* | "Performance without the tradeoff" |
*
* @param {Method_Content_Step_06_Detail_Tournament_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_tournament_2_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Tournament_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Tournament_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_tournament_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_tournament_2_heading(inputs)
	return en_method_content_step_06_detail_tournament_2_heading(inputs)
});